export default __webpack_public_path__ + "static/media/triangle_white.a53ede70.svg";